import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Plane, FileText, GraduationCap, MessageSquare, HeartPulse } from 'lucide-react';
import { PTOAdminTab } from './PTOAdminTab';
import { DocsAdminTab } from './DocsAdminTab';
import { TasksAdminTab } from './TasksAdminTab';
import { RequestsAdminTab } from './RequestsAdminTab';
import { BenefitsAdminTab } from './BenefitsAdminTab';

const TABS = [
  { value: 'pto', label: 'Time Off & Balances', icon: Plane, component: PTOAdminTab },
  { value: 'documents', label: 'Documents', icon: FileText, component: DocsAdminTab },
  { value: 'tasks', label: 'Onboarding & Training', icon: GraduationCap, component: TasksAdminTab },
  { value: 'requests', label: 'HR Requests', icon: MessageSquare, component: RequestsAdminTab },
  { value: 'benefits', label: 'Benefits', icon: HeartPulse, component: BenefitsAdminTab },
];

export default function HRAdmin() {
  return (
    <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-y-auto" data-testid="hr-admin">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-800 mb-1">HR Administration</h1>
        <p className="text-sm md:text-base text-slate-500">Manage employee documents, time off, onboarding and HR requests</p>
      </div>

      <Tabs defaultValue="pto" className="w-full">
        <TabsList className="flex flex-wrap h-auto gap-1 bg-slate-100 p-1 mb-6 justify-start">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} className="gap-1.5 data-[state=active]:bg-white" data-testid={`hr-admin-tab-${t.value}`}>
              <t.icon className="w-4 h-4" />
              <span className="hidden sm:inline">{t.label}</span>
              <span className="sm:hidden">{t.label.split(' ')[0]}</span>
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map((t) => (
          <TabsContent key={t.value} value={t.value}>
            <t.component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
